import React from 'react';
import Barcode from 'react-barcode';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import css from './waybill.less';

const BARCODE_REF_UPPER_LIMIT = 25;
const BARCODE_REF_LOWER_LIMIT = 8;

export const ReferenceCode = ({ refCode }) => {
  if (!refCode) {
    return null;
  }

  const shouldDisplayBarCode =
    refCode.length >= BARCODE_REF_LOWER_LIMIT &&
    refCode.length <= BARCODE_REF_UPPER_LIMIT;

  return (
    <div className={css.referenceCode}>
      {shouldDisplayBarCode && <Barcode value={refCode} displayValue={false} />}
      <p>
        <span className={css.refTitle}>
          {I18n.t('v2.waybill.reference_code')}
        </span>
        <span>{refCode}</span>
      </p>
    </div>
  );
};

ReferenceCode.propTypes = {
  refCode: PropTypes.string,
};

ReferenceCode.defaultProps = {
  refCode: '',
};

export default {};
